import ErrorPage from 'pages/_error';

export default ErrorPage;
